import { RosterPlayers } from 'pages/SetLineup/components/TeamSetup/Roster/RosterStyles';
import { LineupListWrapper } from 'pages/SetLineup/components/TeamSetup/TeamLineup/TeamLineupStyles';
import { TeamSetupPlaceholder } from 'pages/SetLineup/components/TeamSetup/TeamSetupStyles';
import styled from 'styled-components';
import { darkgrey, white } from 'styles/Colors';

export const LineupSelectors = styled.div`
  display: flex;
  justify-content: center;
`;

export const TeamLineupCenter = styled.div`
  background-color: ${white};
  padding: 8px;
  width: 50%;

  &&& ${TeamSetupPlaceholder} {
    margin-top: 0px;
    height: unset;
  }

  ${RosterPlayers} {
    max-height: 472px;
    overflow-y: scroll;
  }

  ${LineupListWrapper} {
    /* overflow-y: scroll;
    max-height: 500px; */
  }
`;

export const TeamName = styled.div`
  height: 64px;
`;

export const Title = styled.span`
  font-size: 13px;
  line-height: 12px;
  color: ${darkgrey};
`;
